import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import logoImg from '../assets/images/logo.png';

const Header = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuToggleRef = useRef(null);
  const mainNavRef = useRef(null);

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const handlePointerDown = (e) => {
      const target = e.target;
      if (
        mobileMenuToggleRef.current?.contains(target) ||
        mainNavRef.current?.contains(target)
      ) {
        return;
      }
      setMobileMenuOpen(false);
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [mobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const doScroll = () => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerHeight = document.querySelector('.site-header')?.offsetHeight ?? 80;
        const top = element.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(doScroll, 150);
    } else {
      doScroll();
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img src={logoImg} alt="iPoolCare" className="logo-image" width={300} height={76} />
        </Link>
        
        <button
          ref={mobileMenuToggleRef}
          type="button"
          className={`mobile-menu-toggle${mobileMenuOpen ? ' is-open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-expanded={mobileMenuOpen}
          aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav ref={mainNavRef} className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <button
            type="button"
            onClick={() => scrollToSection('inicio')}
            className="nav-link nav-link--home"
          >
            Início
          </button>
          <button onClick={() => scrollToSection('pilares')} className="nav-link">Nossos Pilares</button>
          <button onClick={() => scrollToSection('vantagens')} className="nav-link">Vantagens e benefícios</button>
          <button onClick={() => scrollToSection('tecnologia')} className="nav-link">A tecnologia </button>
          <button onClick={() => scrollToSection('nossas-solucoes')} className="nav-link">Nossas Soluções</button>
          <button onClick={() => scrollToSection('depoimentos')} className="nav-link">Depoimentos</button>
          <button onClick={() => scrollToSection('nos')} className="nav-link">Nós</button>
          <button onClick={() => scrollToSection('missao')} className="nav-link">Missão, Visão e Valores</button>
          <button onClick={() => scrollToSection('contato')} className="nav-link">Contato</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;